var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.998,
    height: 149.998,
    viewBox: "0 0 149.998 149.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42669",
    "data-name": "Group 42669",
    transform: "translate(-753 -390.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_366",
    "data-name": "Ellipse 366",
    cx: 63,
    cy: 63,
    r: 63,
    transform: "translate(765 402)",
    fill: "#fffbf5",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41947",
    "data-name": "Group 41947",
    transform: "translate(250 -1213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M12956.219,23912h-94.439a27.753,27.753,0,0,1-27.779-27.779v-94.445a27.757,27.757,0,0,1,27.779-27.773h94.439a27.751,27.751,0,0,1,27.779,27.773v94.445a27.757,27.757,0,0,1-27.779,27.779Zm-81.609-40.867h0v8.988h67.657v-8.988Zm-10.808-65.445a7.166,7.166,0,0,0-1.332.129,7.938,7.938,0,0,0-6.247,7.807c-.1,4.006,2.521,7.6,5.977,8.186,1.54.256,1.932.916,2.227,2.3,1.353,6.359,2.745,12.811,4.091,19.051,1.594,7.387,3.4,15.758,5.139,24,.332,1.564.761,2.219,2.557,2.219h.019c10.063-.037,20.777-.057,32.759-.057,10.062,0,20.446.014,31.747.039,1.468,0,2.184-.289,2.544-2,2.06-9.834,4.212-19.824,6.293-29.486l.018-.08.227-1.051c.92-4.273,1.872-8.691,2.8-13.029.22-1.041.552-1.607,1.753-1.822a7.621,7.621,0,0,0,5.034-3.357,8.435,8.435,0,0,0,1.129-6.521c-.879-3.781-3.808-6.32-7.287-6.32a7.338,7.338,0,0,0-1.781.223,7.631,7.631,0,0,0-4.765,3.783,8.28,8.28,0,0,0-.618,6.58,15.035,15.035,0,0,0,1.809,3.359l0,.006c.344.529.7,1.078,1.033,1.652a90.35,90.35,0,0,1-6.224,8.154,36.106,36.106,0,0,1-7.885,6.854,9.945,9.945,0,0,1-5.194,1.854c-1.937,0-3.77-.943-5.944-3.059a18.917,18.917,0,0,1-1.512-1.662c-5.285-6.631-8.29-14.422-11.2-21.957l0-.008c4.335-2.943,5.856-6.355,4.65-10.43a7.663,7.663,0,0,0-6.937-5.7c-.068,0-.137,0-.2,0a7.6,7.6,0,0,0-6.955,5.1c-1.546,4.146-.259,7.3,4.591,11.252-.616,1.379-1.236,2.834-1.782,4.119a103.308,103.308,0,0,1-4.53,9.7,51.755,51.755,0,0,1-7.357,10.166c-1.64,1.754-3.224,2.572-4.987,2.574a9.2,9.2,0,0,1-4.608-1.529c-6.387-3.738-10.608-9.379-15.081-15.826.171-.162.329-.3.475-.434a8.7,8.7,0,0,0,2.352-9.947A7.41,7.41,0,0,0,12863.8,23805.688Z",
    transform: "translate(-12331 -22159)",
    fill: "#674188"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillSubscription);
export default __webpack_public_path__ + "static/media/Fill_Subscription.68efa5c6d9bb878e68352ff8c0c0bba1.svg";
export { ForwardRef as ReactComponent };